import React from 'react';
import { BooleanInput, Filter, TextInput } from 'react-admin';

import DateInputWrapper from '../../../Common/Utils/DateInputWrapper';

const SearchFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <DateInputWrapper source="updated_after" label="Updated After" />
    <BooleanInput label="Inactive" source="inactive" defaultValue={true} />
  </Filter>
);

export default SearchFilter;



// WEBPACK FOOTER //
// ./src/views/Components/ServerFiles/Helpers/SearchFilter.tsx